<template>
  <a-modal
    title="生成结账单"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item 
        label="账单类型"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        has-feedback
        >
          <a-select  allow-clear placeholder="请选择账单类型" v-decorator="['orderType', { rules: [{ required: true, message: '请选择账单类型！' }] }]" :options="pharmacytypes" style="width:210px"></a-select>
        </a-form-item>
        <a-form-item
          label="账单周期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <!-- <a-input placeholder="请输入账单周期（ex:2023-01）" v-decorator="['billCycle', {rules: [{required: true, message: '请输入账单周期（ex:2023-01）！'}]}]" /> -->
          <a-month-picker allow-clear  format="YYYY-MM" style="width:210px" v-decorator="['billCycle', { rules: [{ required: true, message: '请选择账单周期！' }] }]"  placeholder="请选择周期" />
        </a-form-item>
        <a-form-item
          label="结账人"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入结账人" style="width:210px" v-decorator="['checkoutUser', {rules: [{required: true, message: '请输入结账人！'}]}]" />
        </a-form-item>
        
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { baCheckoutExamAdd } from '@/api/modular/interhospital/bacheckoutexam/baCheckoutExamManage'
  import moment from 'moment'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        checkoutDateDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        pharmacytypes: [
          {
            value: '0',
            label: '挂号',
          },
          {
            value: '1',
            label: '处方',
          },
          {
            value: '5',
            label: '体检',
          },
        ],
      }
    },
  methods: {
      moment,
      // 初始化方法
      add (record) {
        this.visible = true
      },
      /**
       * 提交表单
       */
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          console.log(values)
          if (!errors) {
            // for (const key in values) {
            //   if (typeof (values[key]) === 'object') {
            //     values[key] = JSON.stringify(values[key])
            //   }
            // }
            values.billCycle = moment(values.billCycle).format('YYYY-MM')
            // values.checkoutDate = this.checkoutDateDateString
            baCheckoutExamAdd(values).then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('新增失败')// + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
<style lang="less" scoped>
.ant-calendar-picker-container{
  z-index: 2000;
}
</style>